import { lazy, Suspense, useEffect, useState } from 'react'
import { initThirdPartyCookies, removeThirdPartyCookies } from '@plugins/initThirdPartyCookies'
import { CookieConsent } from '@components/CookieConsent'
import { Outlet, useSearchParams } from 'react-router-dom'
import './AppLayout.scss'
import { getHasAcceptedCookies, setHasAcceptedCookies } from '@plugins/cookies'
import { isIntegratedApp } from '@models/AppType'
import { setIntegrationData } from '@utils/integration'
import OrientationOverlay from '@components/OrientationOverlay/OrientationOverlay.tsx'
import { GotchiCelebrationProvider } from '@context/GotchiCelebrationContext'
import { isDevInspectorEnabled } from '../../dev/devInspectorFlag'
import { isAdminEmbedSession, isAdminPreviewSession } from '../../dev/applyAdminPreviewQuery'
import { AdminPreviewBridge } from '../../dev/AdminPreviewBridge'
import { AdminPreviewAutoConsent } from '../../dev/AdminPreviewAutoConsent'
import { applyLayoutModeToDocument, LAYOUT_MODE_EVENT } from '../../lib/layoutMode'

const LazyDevInspectorCluster = lazy(() => import('../../dev/DevInspectorCluster'))

export const AppLayout = () => {
  const [searchParams] = useSearchParams()
  const [showCookieConsent, setShowCookieConsent] = useState(false)
  const hasAcceptedCookies = getHasAcceptedCookies()
  const adminPreview = isAdminPreviewSession()
  const adminEmbed = isAdminEmbedSession()

  const onAcceptCookies = () => {
    setHasAcceptedCookies(true)
    initThirdPartyCookies()
    setShowCookieConsent(false)
  }

  const onDeclineCookies = () => {
    setHasAcceptedCookies(false)
    removeThirdPartyCookies()
    setShowCookieConsent(false)
  }

  useEffect(() => {
    if (adminPreview) {
      setHasAcceptedCookies(true)
      setShowCookieConsent(false)
      return
    }
    if (hasAcceptedCookies === true) {
      initThirdPartyCookies()
    } else if (hasAcceptedCookies === null) {
      setShowCookieConsent(true)
    }
  }, [hasAcceptedCookies, adminPreview])

  useEffect(() => {
    if (searchParams.toString() && searchParams.get('src') != null) {
      const data = {
        lang: searchParams.get('lng') || 'fr',
        idCamp: '123476',
        CodeSurvey: 'Datagotchi',
        etk: '369ca74c-84fd-4e1d-8f03-17cde9e49dd9',
        flag: 'C',
        ...Object.fromEntries(searchParams.entries()),
      }
      setIntegrationData(data)
    }
  }, [isIntegratedApp, searchParams])

  useEffect(() => {
    applyLayoutModeToDocument()
    const onChange = () => applyLayoutModeToDocument()
    window.addEventListener(LAYOUT_MODE_EVENT, onChange)
    window.addEventListener('storage', onChange)
    return () => {
      window.removeEventListener(LAYOUT_MODE_EVENT, onChange)
      window.removeEventListener('storage', onChange)
    }
  }, [])

  const devInspectorEnabled = isDevInspectorEnabled() && !adminEmbed

  return (
    <div className="AppLayout">
      <GotchiCelebrationProvider>
        <Suspense fallback={<div></div>}>
          {adminPreview && <AdminPreviewAutoConsent />}
          {adminPreview && <AdminPreviewBridge />}
          {devInspectorEnabled && <LazyDevInspectorCluster />}
          <Outlet />
          {!adminPreview && showCookieConsent && (
            <CookieConsent onAcceptCookies={onAcceptCookies} onDeclineCookies={onDeclineCookies} />
          )}
          {!adminEmbed && <OrientationOverlay />}
        </Suspense>
      </GotchiCelebrationProvider>
    </div>
  )
}
